export { default } from './ForecastTableRows';
